import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../utils/api';

const LABELS = {
  branches:   { icon: '📍', title: 'Branches',        desc: 'Select a brand to manage its branches' },
  menu:       { icon: '📝', title: 'Menu Editor',      desc: 'Select a brand to open its menu editor' },
  'price-list': { icon: '📋', title: 'Price Edit',    desc: 'Select a brand to open its price list' },
  qr:         { icon: '⬛', title: 'QR Code',          desc: 'Select a brand to manage its QR code' },
  slides:     { icon: '🎨', title: 'Slide Builder',   desc: 'Select a brand to manage its slides' },
  'info-screens': { icon: '🪧', title: 'Info Screens', desc: 'Select a brand to manage its info screens' },
};

export default function BrandSelect() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const target    = new URLSearchParams(location.search).get('target') || 'menu';

  const [brands,  setBrands]  = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/brands')
      .then(res => {
        const list = res.data;
        setBrands(list);
        if (list.length === 0) { setLoading(false); return; }
        // Auto-navigate to last used or first brand — no manual selection needed
        const stored = localStorage.getItem('pm_last_brand');
        const found  = stored && list.find(b => String(b.id) === stored);
        const brand  = found ? found : list[0];
        localStorage.setItem('pm_last_brand', String(brand.id));
        navigate(`/brands/${brand.id}/${target}`);
      })
      .catch(() => setLoading(false));
  }, [target, navigate]);

  const { icon, title, desc } = LABELS[target] || LABELS.menu;

  if (loading) return <div className="spinner" style={{ marginTop: 60 }} />;

  return (
    <div className="page" style={{ maxWidth: 560 }}>
      <div className="page-header" style={{ marginBottom: 28 }}>
        <h1 className="page-title">{icon} {title}</h1>
      </div>

      <p style={{ fontSize: 14, color: '#888', marginBottom: 20 }}>{desc}</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {brands.map(b => (
          <div key={b.id}
            onClick={() => navigate(`/brands/${b.id}/${target}`)}
            style={{
              display: 'flex', alignItems: 'center', gap: 14,
              padding: '14px 16px', borderRadius: 12, cursor: 'pointer',
              border: '1.5px solid #E0E0E0', background: '#fff', transition: 'all 0.15s',
            }}
            onMouseOver={e => { e.currentTarget.style.borderColor = '#90CAF9'; e.currentTarget.style.background = '#F0F7FF'; }}
            onMouseOut={e => { e.currentTarget.style.borderColor = '#E0E0E0'; e.currentTarget.style.background = '#fff'; }}
          >
            {b.logo_path
              ? <img src={b.logo_path} alt={b.name} style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'contain', background: '#f5f5f5', border: '1px solid #E8E8E8', flexShrink: 0 }} />
              : <div style={{ width: 40, height: 40, borderRadius: 10, background: 'linear-gradient(135deg,#E3F2FD,#BBDEFB)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 18, color: '#1565C0', flexShrink: 0 }}>{b.name?.charAt(0)}</div>}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: 15, color: '#212121', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.name}</div>
              {b.name_ar && <div style={{ fontSize: 12, color: '#aaa', fontFamily: 'Cairo', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.name_ar}</div>}
            </div>
            <span style={{ color: '#BDBDBD', fontSize: 18 }}>›</span>
          </div>
        ))}
        {brands.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px 0', color: '#ccc', fontSize: 14 }}>No brands found</div>
        )}
      </div>
    </div>
  );
}
